module.exports = __webpack_public_path__ + "6371ee0feaedae34399e5caaabc356ce.svg";